export default __webpack_public_path__ + "static/adhdpro-3-bb7837c3ca3c1647dc294deb6d1ba951.png";